import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
const FAQS = [{
  q: '¿En qué formato recibo el material?',
  a: '100% digital (PDF). Lo descargás y lo usás desde cualquier dispositivo.'
}, {
  q: '¿Es para primaria o secundaria?',
  a: 'Está diseñado para docentes en general. Las técnicas se adaptan fácilmente a distintos niveles.'
}, {
  q: '¿Necesito formación previa?',
  a: 'No. Está pensado para aplicar directamente, sin estudiar teoría.'
}, {
  q: '¿Cuándo accedo al material?',
  a: 'De forma inmediata después de la compra.'
}, {
  q: '¿Esto es un curso?',
  a: 'No. Es un sistema práctico de recursos para usar en el aula real.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-gray-50 py-16 md:py-24" data-id="element-39">
      <div className="mx-auto max-w-3xl px-4" data-id="element-40">
        <h2 className="mb-12 text-center text-3xl font-bold text-gray-900" data-id="element-41">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-42">
          {FAQS.map((faq, index) => <div key={index} className="overflow-hidden rounded-lg border border-gray-200 bg-white" data-id="element-43">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="flex w-full items-center justify-between p-6 text-left font-bold text-gray-900 hover:bg-gray-50" data-id="element-44">
                <span data-id="element-45">{faq.q}</span>
                {openIndex === index ? <ChevronUp className="h-5 w-5 text-gray-500" data-id="element-46" /> : <ChevronDown className="h-5 w-5 text-gray-500" data-id="element-47" />}
              </button>

              {openIndex === index && <div className="bg-gray-50 p-6 pt-0 text-gray-600 animate-in slide-in-from-top-2" data-id="element-48">
                  {faq.a}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}